import {NgModule} from '@angular/core';
import {PageCommonModule} from '../shared/page-common.module';
import {FormsModule} from '../../components/forms/forms.module';
import {StepScreenModule} from '../shared/step/step-screen.module';
import {ProfessionalReferenceScreenComponent} from './steps/professional/professional-reference-screen.component';
import {ReferencesPageComponent} from './references-page.component';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    imports: [
        PageCommonModule,
        FormsModule,
        StepScreenModule
    ],
    declarations: [
        ReferencesPageComponent,
        ProfessionalReferenceScreenComponent
    ]
})
export class ReferencesPageModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/references/references-page.module.ts